<template>
   <i class="fa" :class="classes"></i>
</template>

<script>
import { defineComponent } from 'vue'
import { sizes } from './Icon.config'

export default defineComponent({
    /**
     * @type {String}
     * @description This is the name of the component this will also
     * be the tag name of the component to use in templates
     * @example
     * <ak-fa-icon :type="'list" :size="'small'" light></ak-fa-icon>
     */
    name: 'AkFaIcon',

    /**
     * @type {Object}
     * @description A collection of properties that may be passed into
     * the component these will be bound to the component instance and
     * may be access in the template and component methods.
     */
    props: {
        /**
         * @type {Object}
         * @prop {Function}
         * @prop {String}
         * @description Controls the type of the Icon i.e "list"
         */
        type: {
            type: String,
            default: undefined,
        },
        /**
         * @type {Boolean}
         * @description Controls whether the icon is light or solid
         */
        light: {
            type: Boolean,
            default: false,
        },
        /**
         * @type {Object}
         * @prop {Function}
         * @prop {String}
         * @description Controls the size of the Icon i.e "large"
         */
        size: {
        validator: (v) => sizes.indexOf(v) >= 0,
        default: 'default',
        type: String,
        },
        /**
         * @type {Object}
         * @prop {Function}
         * @prop {String}
         * @description Controls the color of the Icon i.e "primary"
         */
        color: {
        default: undefined,
        type: String,
        },
    },

    /**
     * @param {Object} props - The properties of the component
     * @description Sets up the component and returns an object containing all of the
     * attributes for the component to use.
     */
    setup(props) {
        const light = props.light ? 'fa-light' : 'fa-solid'
        const type = `fa-${props.type}`
        const size = `ak-icon--${props.size}`
        const color = `color-${props.color}`

        const classes = [
            light,
            type,
            size,
            color
        ]
        return {classes}
    }
})

</script>